module.exports = __webpack_public_path__ + "img/logo.b0cbe9a3.png";